import { connect } from 'react-redux';
import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';

import PurchasePpdCheckout from '../../components/purchase/PurchasePpdCheckout';
import { checkoutPrice } from '../../graphql/queries/checkout';
import { MeQuery, MeForPrintCheckout } from '../../graphql/queries/account';
import { getAlbumCheckoutItems } from '../../util/ppd-purchase';
import { checkout as checkoutMutation } from '../../graphql/mutations/checkout';
import { checkout } from '../../actions/ppd-purchase';
import { AlbumForPpdPurchase } from '../../graphql/queries/albums';
import withPurchasePpdCartItemToggle from './withPurchasePpdCartItemToggle';

const withMe = graphql(MeQuery, {
  props: ({ data: { me } }) => ({
    userId: me?.id,
  }),
});

const withCheckoutPrice = graphql(checkoutPrice, {
  options: ({ cart, userId, userAddress, album }) => {
    const { ppaItems, customPrintItems, photoItems } = getAlbumCheckoutItems(
      cart,
      album,
    );

    return {
      variables: {
        account_id: userId,
        address_id: userAddress?.id,
        subscription_items: ppaItems,
        custom_print_items: customPrintItems,
        photo_items: photoItems,
      },
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: true,
    };
  },
  props: ({ data: { checkoutPrice: price, loading } = {} }) => ({
    price,
    loadingPrice: loading,
  }),
  skip: ({ userId, cart, album }) =>
    !cart || !userId || !album || cart.length === 0,
});

const withCheckout = graphql(checkoutMutation, {
  props: ({ mutate }) => ({
    checkoutMutation: ({
      userId,
      photoItems,
      ppaItems,
      customPrintItems,
      addressId,
      email,
      stripeTokenId,
      stripePaymentMethodId,
      stripeConnectAccountId,
    }) =>
      mutate({
        variables: {
          input: {
            photo_items: photoItems,
            subscription_items: ppaItems,
            custom_print_items: customPrintItems,
            account_id: userId,
            account_address_id: addressId,
            stripe_token: stripeTokenId,
            email_address: email,
            platform: 'WEB',
            stripe_payment_method_id: stripePaymentMethodId,
            stripe_connect_account_id: stripeConnectAccountId,
          },
        },
      }),
  }),
});

const withUserAddresses = graphql(MeForPrintCheckout, {
  props: ({ data: { me } }) => {
    const [userAddress] = me?.addresses ?? [];

    return {
      userAddress,
    };
  },
});

const withAlbumForPpdPurchase = graphql(AlbumForPpdPurchase, {
  options: ({ match }) => ({
    variables: {
      id: match.params.albumId,
    },
  }),
  props: ({ data: { album, loading }, ownProps }) => ({
    album,
    loading: ownProps.loading || loading,
  }),
});

const mapStateToProps = ({ ppdPurchase }) => ({
  cart: ppdPurchase.cart,
  loading: ppdPurchase.loading,
  success: ppdPurchase.success,
  error: ppdPurchase.error,
});

const mapDispatchToProps = {
  checkout,
};

export default compose(
  withPurchasePpdCartItemToggle,
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withMe,
  withUserAddresses,
  withAlbumForPpdPurchase,
  withCheckoutPrice,
  withCheckout,
)(PurchasePpdCheckout);
